import { useEffect, useState, useCallback } from 'react';
import {
  suscribirseAEvento,
  desuscribirseDeEvento,
  onAsientoUpdate,
  offAsientoUpdate,
  isAsientosConnected
} from '../components/Socket/asiento';

export const useAsientosRealtime = (eventoId, enabled = true) => {
  const [isConnected, setIsConnected] = useState(false);
  const [callbacks, setCallbacks] = useState([]);

  // callback de actualizacion
  const addUpdateCallback = useCallback((callback) => {
    setCallbacks(prev => [...prev, callback]);
  }, []);

  // elimina el callback
  const removeUpdateCallback = useCallback((callback) => {
    setCallbacks(prev => prev.filter(cb => cb !== callback));
  }, []);

  const handleAsientoUpdate = useCallback((data) => {
    console.log('🔄 Asiento actualizado en tiempo real:', data);
    callbacks.forEach(callback => callback(data));
  }, [callbacks]);

  useEffect(() => {
    if (!enabled || !eventoId) return;

    suscribirseAEvento(eventoId);

    // escuchar las actualizaciones
    onAsientoUpdate(handleAsientoUpdate);

    // verificar la conexion
    const checkConnection = () => {
      setIsConnected(isAsientosConnected());
    };

    checkConnection();
    const interval = setInterval(checkConnection, 2000);

    return () => {
      desuscribirseDeEvento(eventoId);
      offAsientoUpdate();
      clearInterval(interval);
      setIsConnected(false);
    };
  }, [eventoId, enabled, handleAsientoUpdate]);

  return {
    isConnected,
    addUpdateCallback,
    removeUpdateCallback
  };
};